// extracted by mini-css-extract-plugin
export default {"SubPage":"SubPage_SubPage__Eha6D","backLink":"SubPage_backLink__GzRYQ","onMobile":"SubPage_onMobile__kot2t"};